import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { LOCAL_STORAGE_KEYS } from '../constants/constants';

const useAuth = () => {
	const accountId = useSelector((state) =>
		state.getIn(['customerAccount', 'accountId']),
	);
	const tenantId = useSelector((state) =>
		state
			.getIn(['auth', 'customersActiveRealm'])
			?.SecurityAuthenticationRealmName?.toLowerCase(),
	);

	const getAuthHeaders = useCallback(() => {
		const token = localStorage.getItem(LOCAL_STORAGE_KEYS.customerAccountToken);
		if (!token || !tenantId) return null;
		return {
			'X-Tenant-Id': tenantId,
			Authorization: `Bearer ${token}`,
		};
	}, [tenantId]);

	return {
		accountId,
		getAuthHeaders,
	};
};

export default useAuth;
